import { LeadType } from '@/lib/entities/lead';

import { Button } from '@/lib/shared/components/Buttons';
import { modal, FeedBackModal } from '@/lib/shared/components/Modal';
import { P3 } from '@/lib/shared/components/Typography';

import cn from 'clsx';
import { useTranslation } from 'next-i18next';

import styles from './empty-state.module.scss';

type EmptyStateProps = {
  resetFilters: () => void;
  type: 'sale' | 'rent';
};

export const EmptyState = ({ resetFilters, type }: EmptyStateProps) => {
  const { t } = useTranslation('index');
  const toCallModal = () => {
    modal.open(
      <FeedBackModal
        leadType={type.toUpperCase() as LeadType}
        eventName={[type]}
      />,
      {
        isFeedBack: true,
      }
    );
  };
  return (
    <div className={styles.emptyState}>
      <div className={cn(styles.container, styles.emptyState__info)}>
        <P3 className={styles.emptyState__text}>{t('emptyResult')}</P3>
        <P3 className={styles.emptyState__text}>{t('callManager')}</P3>
        <div className={styles.emptyState__buttonWrapper}>
          <Button
            as={'button'}
            type={'button'}
            label={t('form.buttons.requestACall')}
            theme={'dark'}
            size={'lg'}
            onClick={toCallModal}
          />
          <Button
            as={'button'}
            type={'button'}
            label={t('resetFilters')}
            theme={'secondary'}
            size={'lg'}
            onClick={resetFilters}
          />
        </div>
      </div>
    </div>
  );
};
